const initialState = {
   suggestions: [],
}

export default function (state = initialState, action) {
    switch (action.type) {
        case 'GET_GOOGLE_PLACES_FULFILLED': {
            let suggestions = action.payload.data.map(result => result.description);
            return {...state, suggestions};
        }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/googlePlacesReducer.js